export enum QuantityState {
  NoDangerousGood = 0,
  NotSubjectOfRegulation = 1,
  ExceptedQuantity = 2,
  LimitedQuantity = 3,
  FullDangerousGood = 4,
  CargoAircraftOnly = 5,
  ForbiddenToTransport = 6
}
